import React, { useEffect, useState } from "react";
import { createCompany, getCompanies, getStatus, studentRegister, userRegister } from "../../Services/MasterService";
import { toast } from "react-toastify";

const AddStudent = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        fname: null,
        mname: null,
        lname: null,
        email: null,
        phone: null,
        password: null,
        dob: null,
        status: null,
        company_id: null
    });
    const [loader, setLoader] = useState(false);
    const [status, setStatus] = useState([]);
    const [company, setCompany] = useState([]);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isNotAllowed = Boolean(!reqData?.status || !reqData?.company_id);
        if (isNotAllowed) {
            toast.error("Status and Company are required");
        } else {
            setLoader(true);
            let { ok } = await studentRegister(reqData);
            if (ok) {
                toast.success("Success");
                onCloseWithApi();
            }
            setLoader(false);
        }
    };

    const getStatusCall = async () => {
        let { ok, data } = await getStatus({});
        if (ok) {
            setStatus(data?.records);
        }
    };

    const getCompanyCall = async () => {
        let { ok, data } = await getCompanies({});
        if (ok) {
            setCompany(data?.records);
        }
    };

    useEffect(() => {
        getStatusCall();
        getCompanyCall();
        if (data?.data) {
            const { id, fname, mname, lname, email, phone, password, dob, status, company_id } = data?.data;
            setReqData({ id, fname, mname, lname, email, phone, password, dob, status, company_id })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Student" : "Edit Student"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>First Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="First Name"
                                                required
                                                value={reqData?.fname}
                                                onChange={(e) => handleChange("fname", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Middle Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Middle Name"
                                                value={reqData?.mname}
                                                onChange={(e) => handleChange("mname", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Last Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Last Name"
                                                required
                                                value={reqData?.lname}
                                                onChange={(e) => handleChange("lname", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Email</label>
                                            <input
                                                disabled={reqData?.id}
                                                type="email"
                                                className="form-control"
                                                placeholder="Email"
                                                required
                                                value={reqData?.email}
                                                onChange={(e) => handleChange("email", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Password</label>
                                            <input
                                                disabled={reqData?.id}
                                                type="text"
                                                className="form-control"
                                                placeholder="Password"
                                                onChange={(e) => handleChange("password", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Phone</label>
                                            <input
                                                disabled={reqData?.id}
                                                type="number"
                                                className="form-control"
                                                placeholder="Phone"
                                                required
                                                value={reqData?.phone}
                                                onChange={(e) => handleChange("phone", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>DOB</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                placeholder="DD/MM/YYYY"
                                                value={reqData?.dob}
                                                onChange={(e) => handleChange("dob", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Status</label>
                                            <select required value={reqData?.status} onChange={(e) => handleChange("status", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Status</option>
                                                {status?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Company</label>
                                            <select required value={reqData?.company_id} onChange={(e) => handleChange("company_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Company</option>
                                                {company?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddStudent;